import { FaxConfigurationControllerApi, FaxConfiguration } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  faxIntegration: FaxConfiguration;
  xTENANTID?: string;
}

  export const useAddFaxIntegration = () =>
  useMutationWithLoading(async (params: Params) =>
    new FaxConfigurationControllerApi(getConfigObject()).addConfiguration(
      params.faxIntegration,
      params.xTENANTID
    )
  );
